// Comparator for alphabetical lists: case-insensitive and numeric-aware ("Tank 2" before "Tank 10"), blank names last.
// Hex device ids (e.g. e6647c156720ab26) compare as plain text, since their digit runs aren't numbers.
const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
const textCollator = new Intl.Collator(undefined, { sensitivity: 'base' });
const isHexId = (name) => /^[0-9a-f]{8,}$/i.test(name);

export const byName = (getName) => (a, b) => {
  const nameA = (getName(a) ?? '').toString().trim();
  const nameB = (getName(b) ?? '').toString().trim();
  if (!nameA || !nameB) return !nameA - !nameB;
  return (isHexId(nameA) || isHexId(nameB) ? textCollator : collator).compare(nameA, nameB);
};

// The name a My View card shows: gateway labels are "deviceName - gatewayName", so drop the device part.
export const cardLabel = (label) => {
  if (label && label.includes(' - ')) {
    return label.split(' - ').slice(1).join(' - ');
  }
  return label;
};
